import { CallState, HotelCfarCancelScenario } from "redmond";
import { put } from "redux-saga/effects";
import { getCfarHotelCancellationPolicy } from "../../../api/v1/itinerary/getCfarCancellationPolicy";
import Logger from "../../../utils/logger";

import { actions } from "../actions";
import { IFetchHotelCfarCancellationPolicy } from "../actions/actions";

export function* fetchHotelCfarCancellationPolicySaga(
  action: IFetchHotelCfarCancellationPolicy
) {
  const ttl = 15 * 60 * 1000;

  try {
    const { request } = action;

    const response: HotelCfarCancelScenario =
      yield getCfarHotelCancellationPolicy(request);

    yield put(
      actions.setHotelCfarCancellationPolicyScenario({
        response,
        expires: Date.now() + ttl,
      })
    );
  } catch (e) {
    yield put(
      actions.setHotelCfarCancellationPolicyCallState(CallState.Failed)
    );
    Logger.debug(e);
  }
}
